<template>
  <div class="page_content major_minor_list explore_entity_result" v-if="permission && permission.version === '5'" aria-label="Major Minor List page">

    <div class="page_heading">
      <div class="col-8 module_heading" role="heading" aria-level="1">
        <span class="major_minor_icon icon-list"></span>
        <span class="program_guide_title module_type_name">Major Minor Management</span>
      </div>

      <div class="col-4 btn_container">
        <button class="btn btn-primary" aria-label="upload" :disabled="!permission.institutionPermission.canUploadMajorMinors" @click="goToUploadPage">upload</button>
        <button class="btn btn-primary" aria-label="delete all" :disabled="(totalElements === 0) || permission.systemPermission.readOnly" @click.prevent="showDeleteAllConfirm">delete all</button>
        <button type="button" class="btn btn-primary" :disabled="(selected.length === 0)" @click.prevent="showDeleteConfirm" aria-label="delete">delete</button>
      </div>
    </div>

    <div class="user-management-section">
      <div class="page_subheading">
        <div class="select-all-container checkbox_container">
          <label class="form-checkbox">
            <input type="checkbox" v-model="selectAll" @click="select" :disabled="(majorMinors.length === 0) || permission.systemPermission.readOnly" aria-label="select all major minors">
            <i class="form-icon"></i>
          </label>
        </div>
        <div class="toolbar-right ui-list-toolbar">
          <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
            <option v-for="option in sizeOptions" v-bind:value="option">
              {{ option }}
            </option>
          </select>
          <div class="btn_container pagination_sty3">
            <button type="button" :disabled="firstPage" @click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="page_count" aria-hidden="true">{{ page + 1 }}</span>
            <button type="button" :disabled="lastPage" @click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
          <div class="search-box-container">
            <input type="text" class="input-search" placeholder="search by name" aria-label="search by name" v-model="searchName" v-on:keyup.enter="searchMajorMinors">
            <button type="button" class="btn btn_srh" @click="searchMajorMinors" aria-label="search major minor">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>

		  <div class="table_containers page_content_container">
      	<div v-if="isMajorMinorsLoaded" class="table list_container">

      		<div v-if="formattedMajorMinors && formattedMajorMinors.length > 0">
        		<div v-for="majorMinor in formattedMajorMinors" class="row result_row">

          			<div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 ace_sec checkbox_container">
                  <div class="row">
                    <label class="form-checkbox">
                      <input type="checkbox" :value="majorMinor.uuid" v-model="selected" :disabled="(majorMinors.length === 0) || permission.systemPermission.readOnly" aria-label="select major minor">
                      <i class="form-icon"></i>
                    </label>
                  </div>
                </div>

                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 thumbnail_section ace_sec">
          				<div class="thumbnail_container ace_sec">
          					<img v-if="majorMinor.thumbnailURI" :src="majorMinor.thumbnailURI" style="width: 100%; height: auto;">
						        <div v-else class="thumbnail_default icon-list"></div>
          				</div>
          			</div>

          			<div class="col-xl-9 col-lg-9 col-md-9 col-sm-8 entity_detail_section">
          				<div class="row">

          					<div class="col-xl-7 col-lg-7 col-md-7 col-sm-4">
              				<div class="lst_fld name">{{ majorMinor.name }}</div>
              				<div class="lst_fld fld_row_2">Code: {{ majorMinor.code }}</div>
                      <div class="lst_fld fld_row_2"><b-link class="btn" @click="previewWidget(majorMinor)">Preview Widget</b-link></div>
              			</div>
              			<div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
              				<div class="lst_fld">Cip Code: {{ majorMinor.cipCode }}</div>
                      <div class="lst_fld fld_row_2" v-if="widget.uuid"><b-link class="btn" @click="generateEmbedCode(majorMinor)">Generate Embed Code</b-link></div>
              				<div class="lst_fld fld_row_2">Related Code: {{ majorMinor.relatedCipCodesString }}</div>
              			</div>
              			<div class="col-xl-1 col-lg-1 col-md-1 col-sm-1">
                			<template v-if="permission.systemPermission.readOnly">
                  			<span class="ic_btn ic2_pencil" aria-label="edit" tabindex="0" @click="goToEditPage(majorMinor)" style="pointer-events: none; color: #ccc;"></span>
                			</template>
                			<template v-else>
                  			<span class="ic_btn ic2_pencil" aria-label="edit" tabindex="0" @click="goToEditPage(majorMinor)" style="cursor: pointer;"></span>
                			</template>
              			</div>

          				</div>
          			</div>

        		</div>
      		</div>

      		<div v-else class="no-result">
      		  <div colspan="4" style="text-align:center;">No Results Found</div>
      		</div>
      	</div>

		  </div>
    </div>

    <div>
      <b-modal class="widget_container_v2" ref="previewWidgetModal" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="header-section">
          <div class="popup_head_txt head_txt"></div>
          <button class="btn_close" aria-label="close" @click="closePreviewWidget">
            <span class="ic-close"></span>
          </button>
        </div>
        <div style="text-align: center;">
          <widget-program-guide-career-prospects-detail :cipCode="selectedMajor.cipCode" :programGuideCode="selectedMajor.code" :key="programGuideKey" :institutionId="selectedMajor.institutionId" :majorTitle="selectedMajor.name" :introductionMessage="introductionMessage">
          </widget-program-guide-career-prospects-detail>
        </div>

        <div slot="modal-footer" class="w-100">
          <b-button @click="closePreviewWidget" class="btn button-primary next float-right mr-2" aria-label="cancel"> close </b-button>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal class="delete-folder-popup" ref="embedWidgetModal" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="header-section">
          <p>Script to embed in your website</p>
          <div>
            <code>
              {{selectedEmbedScript}}
            </code>
          </div>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="closeEmbedWidget" class="btn button-primary next float-right mr-2" aria-label="cancel"> close </b-button>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal class="delete-folder-popup" ref="deleteConfirmModal" no-close-on-backdrop no-close-on-esc centered>
        <div style="text-align: center;">
          <h6>Are you sure you want delete these ({{ selected.length }}) Major Minors?</h6>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="popup-heading">Please Confirm!</div>
          <button class="btn_close" aria-label="close" @click="cancelDelete">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal class="delete-folder-popup" ref="deleteAllConfirmModal" no-close-on-backdrop no-close-on-esc centered>
        <div style="text-align: center;">
          <h6>Are you sure you want delete all ({{totalElements}}) Major Minors?</h6>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="popup-heading">Please Confirm!</div>
          <button class="btn_close" aria-label="close" @click="cancelDeleteAll">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteAllMajorMinors" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="cancelDeleteAll" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
import '../../../assets/module/css/user/userList.min.css'
import WidgetProgramGuideCareerProspectsDetail from './WidgetProgramGuideCareerProspectsDetail'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'major-minor-list',
  components: {
    WidgetProgramGuideCareerProspectsDetail
  },
  data () {
    return {
      pageSize: 10,
      sizeOptions: [ 10, 50, 100 ],
      firstPage: true,
      lastPage: true,
      page: 0,
      totalPages: 0,
      totalElements: 0,
      majorMinors: [],
      isMajorMinorsLoaded: false,
      majorMinorDeleteMessage: '',
      majorMinorToBeDeleted: {},
      searchName: '',
      selected: [],
      selectAll: false,
      widget: {},
      selectedMajor: {},
      programGuideKey: 0,
      introductionMessage: '',
      embedScript: '',
      selectedEmbedScript: '',
      userObject: JSON.parse(localStorage.getItem('userobj'))
    }
  },

  mounted () {
    this.loadPermission().then(res => {
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.loadMajorMinorList()
      }, 500)
    })
  },
  methods: {
    ...mapActions([
      'loadMajorMinors',
      'loadPermission',
      'deleteMajorMinors',
      'bulkDeleteMajorMinor',
      'loadWidgetDetail'
    ]),
    async loadMajorMinorList () {
      this.loadMajorMinors({page: this.page, count: this.pageSize, name: this.searchName}).then(result => {
        this.majorMinors = result.content
        this.page = result.number
        this.firstPage = result.first
        this.lastPage = result.last
        this.totalPages = result.totalPages
        this.totalElements = result.totalElements
        this.isMajorMinorsLoaded = true
        this.$refs.loadingModal.hide()
        if (this.selectAll) {
          this.selected = []
          this.selectAll = false
        }
      })
      let res = await this.loadWidgetDetail({uuid: this.userObject.institutionId, type: 'EXPLORE'})
      if (res) {
        this.widget = res
        this.embedScript = res.embeddableScript
      }
    },
    previewWidget (majorMinor) {
      this.selectedMajor = majorMinor
      this.programGuideKey = this.programGuideKey + 1
      this.$refs.previewWidgetModal.show()
    },
    closePreviewWidget () {
      this.selectedMajor = {}
      this.$refs.previewWidgetModal.hide()
    },
    generateEmbedCode (majorMinor) {
      this.selectedEmbedScript = this.embedScript
      this.selectedEmbedScript = this.selectedEmbedScript.replace('52.0201', majorMinor.cipCode)
      this.selectedEmbedScript = this.selectedEmbedScript.replace('BBA', majorMinor.code)
      this.$refs.embedWidgetModal.show()
    },
    closeEmbedWidget () {
      this.selectedEmbedScript = ''
      this.$refs.embedWidgetModal.hide()
    },
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (var i in this.majorMinors) {
          this.selected.push(this.majorMinors[i].uuid)
        }
      }
    },
    showDeleteConfirm () {
      if (this.selected.length > 0) {
        this.$refs.deleteConfirmModal.show()
      }
    },
    deleteSelected () {
      this.$refs.deleteConfirmModal.hide()
      this.$refs.loadingModal.show()
      this.deleteMajorMinors(this.selected).then(res => {
        if (res) {
          if (res.succeeded > 0) {
            let message = '' + res.succeeded + ' Major Minor(s) deleted successfully.'
            setTimeout(() => {
              this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: message
              })
            }, 0)
          }
          if (res.unauthorized > 0) {
            let message = '' + res.unauthorized + ' Major Minor(s) not deleted due to lack of permission.'
            setTimeout(() => {
              this.$notify({
                group: 'notify',
                type: 'warn',
                title: '',
                text: message
              })
            }, 500)
          }
        } else {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Major Minor deletion failed due to a network issue.'
          })
        }
        setTimeout(() => {
          this.loadMajorMinorList()
        }, 1000)
      })
      this.selected = []
      this.selectAll = false
    },
    cancelDelete () {
      this.$refs.deleteConfirmModal.hide()
      this.selected = []
      this.selectAll = false
    },
    showDeleteAllConfirm () {
      this.$refs.deleteAllConfirmModal.show()
    },
    cancelDeleteAll () {
      this.$refs.deleteAllConfirmModal.hide()
    },
    deleteAllMajorMinors () {
      this.$refs.deleteAllConfirmModal.hide()
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.bulkDeleteMajorMinor().then(resp => {
          if (resp) {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Successfully deleted all the Major Minors'
            })
          }
          this.loadMajorMinorList()
        })
      }, 500)
    },
    goToUploadPage () {
      return this.$router.push({name: 'majorMinorUpload'})
    },
    goToEditPage (majorMinor) {
      return this.$router.push({ name: 'majorMinorEdit', params: { cipCode: majorMinor.cipCode, code: majorMinor.code } })
    },
    searchMajorMinors () {
      this.page = 0
      this.loadMajorMinorList()
    },
    resetPage () {
      this.page = 0
      this.loadMajorMinorList()
    },
    prev () {
      this.page = this.page - 1
      this.loadMajorMinorList()
    },
    next () {
      this.page = this.page + 1
      this.loadMajorMinorList()
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission
    }),
    formattedMajorMinors () {
      let majorMinors = this.majorMinors
      majorMinors.forEach(majorMinor => {
        majorMinor.relatedCipCodesString = ''
        if (majorMinor.relatedCipCodes && majorMinor.relatedCipCodes.length > 0) {
          majorMinor.relatedCipCodesString = majorMinor.relatedCipCodes.join(', ')
        }
      })
      return majorMinors
    }
  }
}
</script>

<style scoped>
.major_minor_icon {
  float:left;
  width:30px;
  font-size: 24px;
  margin:3px 3px 0 0 !important;
}
.explore_entity_result .page_content_container .list_container {
  width: calc(100% - 40px);
  margin-left: 20px;
}
.checkbox_container {
  max-width: 50px;
  flex: 0 0 50px;
}
.explore_entity_result .page_content_container .result_row .entity_detail_section {
  max-width: calc(100% - 310px);
}
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/MajorMinorList.vue